import type {
  GroupEdgeSettings,
  ProtocolEdgeType,
  TopologyEdgeSettings,
  TopologyGraphEdgeSettings,
  TopologyGraphPreset,
} from '@ipfabric/utils';
import { isTopologyProtocolSettings } from 'components/Graph/GraphState';

export const getSettingsEntity = (
  preset: TopologyGraphPreset,
  groupId: GroupEdgeSettings['id'] | null,
  protocolName?: ProtocolEdgeType,
): TopologyGraphEdgeSettings | undefined => {
  if (groupId !== null) {
    const foundGroup = preset.edges.find(
      (group: TopologyGraphEdgeSettings): group is GroupEdgeSettings =>
        group.id === groupId,
    );
    if (foundGroup) {
      // protocol in group
      if (protocolName) {
        return foundGroup.children.find(
          (protocol): protocol is TopologyEdgeSettings =>
            isTopologyProtocolSettings(protocol) &&
            protocol.name === protocolName,
        );
      }
      // group
      return foundGroup;
    }
    return undefined;
  }
  // protocol in Others group
  return preset.edges.find(
    (item: TopologyGraphEdgeSettings): item is TopologyEdgeSettings =>
      item.type === 'protocol',
  );
};
